import React from 'react';
import Icon from '@ant-design/icons';

const warnSvg = () => {
    return (
        <svg width="66" height="58" viewBox="0 0 66 58" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 57.5H66L33 0.5L0 57.5ZM36 48.5H30V42.5H36V48.5ZM36 36.5H30V24.5H36V36.5Z" fill="#F0A40F" />
        </svg>
    );
};

const infoSvg = () => {
    return (
        <svg width="58" height="58" viewBox="-1.5 -1.5 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16.5" cy="16.5" r="16" stroke="black" stroke-width="3" fill="none" />
            <path d="M14.85 8.25H18.15V11.55H14.85V8.25ZM14.85 14.85H18.15V24.75H14.85V14.85Z" fill="black" />
        </svg>
    );
};

const successSvg = () => {
    return (
        <svg
            width="58" height="58"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
        >
            <circle cx="12" cy="12" r="12" fill="#3ba83b"></circle>
            <polyline points="7 12 10 15 17 9" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></polyline>
        </svg>
    );
};

const failedSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58">
            <circle cx="29" cy="29" r="29" fill="#cd3434" />
            <line x1="20" y1="20" x2="38" y2="38" stroke="white" stroke-width="4" />
            <line x1="38" y1="20" x2="20" y2="38" stroke="white" stroke-width="4" />
        </svg>
    );
};


const StatusIcon = {
    info: props => <Icon component={infoSvg} {...props} />,
    warn: props => <Icon component={warnSvg} {...props} />,
    success: props => <Icon component={successSvg} {...props} />,
    failed: props => <Icon component={failedSvg} {...props} />,
}

export default StatusIcon;
